module.exports = __webpack_public_path__ + "static/media/full-account-outline.6ff07157.svg";